import makeStyles from '@mui/styles/makeStyles';
import { checkboxLabel } from '../AssociateTenants/parts/shared/ui/styles';

export const createClasses = makeStyles(theme => ({
  container: {
    maxWidth: '450px'
  },

  heading: {
    maxWidth: '353px',
    marginBottom: theme.spacing(1),

    '& span': {
      color: theme.palette.secondary[500]
    }
  },

  subtitle: {
    color: theme.palette.primary[400],
    marginBottom: theme.spacing(4)
  },

  inputLabel: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5)
  },

  icon: {
    fontSize: theme.typography.body1.fontSize
  },

  warning: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.error[200],
    borderRadius: '4px',

    '& span': {
      color: theme.palette.secondary[500]
    }
  },

  warningIcon: {
    marginBottom: theme.spacing(1.75)
  },

  checkbox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    height: '17px',

    '& span': {
      paddingLeft: 0
    }
  },
  loader: {
    marginTop: theme.spacing(3)
  },
  attentionBoxWrapper: {
    marginTop: theme.spacing(3)
  },
  attentionCheckbox: checkboxLabel(theme)
}));
